// "2026-03" → "Mar '26" for chart axes.
export function monthLabel(month: string): string {
  const [y, m] = month.split('-').map(Number)
  if (!y || !m) return month
  const d = new Date(Date.UTC(y, m - 1, 1))
  return `${d.toLocaleString('en-US', { month: 'short', timeZone: 'UTC' })} '${String(y).slice(2)}`
}
